import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import PrimaryButton from "shared/components/PrimaryButton";
import Modal from "shared/components/Modal";
import _str from "shared/util/_str";
import Str from "shared/components/Str";
import { viewedFirstPartyPromoEvent } from "routers/Desktop/NavBar/components/util/analytics";

import "./FinishedBoostModal.scss";

const FinishedBoostModal = ({ boostAgain, onClose, show, viewMultiplier, thumbnail }) => {
	useEffect(() => {
		if (show) {
			viewedFirstPartyPromoEvent();
		}
	}, [show]);

	const cachedViewMultiplier = useRef();
	useEffect(() => {
		if (viewMultiplier !== null) {
			cachedViewMultiplier.current = viewMultiplier;
		}
	}, [show, viewMultiplier]);

	return (
		<Modal
			className="finished-boost-modal"
			onCancel={onClose}
			show={show}
			willCloseOnClick
			noClose
		>
			<div className="finished-boost-modal-image">
				<img
					className="finished-boost-modal-image-thumb"
					alt="profile"
					src={thumbnail}
				/>
			</div>
			<div className="finished-boost-modal-text">
				<div className="finished-boost-modal-title">
					{_str("Your Boost worked!")}
				</div>
				<p className="finished-boost-modal-body">
					{_str("You just increased your profile views ")}
					{" "}
					{`${cachedViewMultiplier.current}x.`}
				</p>
			</div>
			<div className="finished-boost-modal-footer">
				<PrimaryButton
					onClick={boostAgain}
				>
					<Str>Boost Again</Str>
				</PrimaryButton>
				<button
					className="finished-boost-modal-close-button"
					onClick={onClose}
				>
					<Str>No Thanks</Str>
				</button>
			</div>
		</Modal>
	);
};

FinishedBoostModal.propTypes = {
	boostAgain: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	show: PropTypes.bool,
	viewMultiplier: PropTypes.number,
	thumbnail: PropTypes.string.isRequired,
};

FinishedBoostModal.defaultProps = {
	show: false,
	viewMultiplier: 1.1,
};

export default FinishedBoostModal;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/BoostButton/FinishedBoostModal/FinishedBoostModal.jsx